export interface DownloadItem {
  label: string;
  key: 'source' | 'target' | 'dual';
}

const DEFAULT_DOWNLOAD_ITEMS: DownloadItem[] = [
  {
    label: '源文件',
    key: 'source',
  },
  {
    label: '译文文件',
    key: 'target',
  },
];

export function getDownloadItems(filename: string): DownloadItem[] {
  if (filename.split('.').pop()?.toLowerCase() !== 'pdf') {
    return DEFAULT_DOWNLOAD_ITEMS;
  }

  return [
    ...DEFAULT_DOWNLOAD_ITEMS,
    {
      label: '整合文件',
      key: 'dual',
    },
  ];
}
